export const AYURVEDA_MEDICINES = [
  {
    Name: "Triphala Churna",
    Ingredients: ["1 teaspoon of Triphala Churna", "1 cup of warm water"],
    Instructions: [
      "Measure one teaspoon of Triphala Churna.",
      "Boil a cup of water and let it cool slightly.",
      "Add the Triphala Churna to the warm water.",
      "Stir well until it dissolves.",
      "Drink this mixture in the evening before bedtime for digestive support and detoxification.",
    ],
    CommonUsage: "Evening before bedtime",
    link: "https://www.keralaayurveda.biz/media/blogs/NPD/Blog%201.png",
  },
  {
    Name: "Ashwagandha Powder",
    Ingredients: [
      "1 teaspoon of Ashwagandha powder",
      "1 cup of warm milk or water",
    ],
    Instructions: [
      "Measure one teaspoon of Ashwagandha powder.",
      "Heat a cup of milk or water until warm (not boiling).",
      "Add the Ashwagandha powder to the warm liquid.",
      "Stir well until the powder is fully dissolved.",
      "Consume this mixture in the evening for stress relief and vitality.",
    ],
    CommonUsage: "Evening",
    link: "https://5.imimg.com/data5/SELLER/Default/2023/4/304138748/SM/KT/KU/98758710/organic-ashwagandha-powder.jpg",
  },
  {
    Name: "Amla Rasayan",
    Ingredients: [
      "Fresh Amla (Indian Gooseberry) or Amla powder",
      "Honey (optional)",
    ],
    Instructions: [
      "If using fresh Amla, extract the juice from a few Amla fruits.",
      "Mix the Amla juice with a teaspoon of honey (optional).",
      "Consume this mixture in the morning on an empty stomach for its high vitamin C content and immune-boosting properties.",
    ],
    CommonUsage: "Morning on an empty stomach",
    link: "https://feeds.abplive.com/onecms/images/uploaded-images/2021/11/21/860e719c1030736280d3a3ff715d6b7e_original.jpg",
  },
  {
    Name: "Trikatu Churna",
    Ingredients: [
      "1/2 teaspoon of Trikatu Churna (a mixture of black pepper, long pepper, and ginger)",
      "1 cup of hot water",
    ],
    Instructions: [
      "Measure half a teaspoon of Trikatu Churna.",
      "Boil a cup of water and let it cool slightly.",
      "Add the Trikatu Churna to the hot water.",
      "Stir well and let it steep for a few minutes.",
      "Drink this mixture after meals for digestive support and to boost metabolism.",
    ],
    CommonUsage: "After meals",
    link: "https://www.indianproductsstore.com/uploads/products/thirikaduham-sukku-milagu-thipili-trikatu-churna-powder.jpg",
  },
  {
    Name: "Brahmi Ghrita",
    Ingredients: ["1 teaspoon of Brahmi Ghrita", "Warm milk or water"],
    Instructions: [
      "Measure one teaspoon of Brahmi Ghrita.",
      "Heat a cup of milk or water until warm (not boiling).",
      "Add the Brahmi Ghrita to the warm liquid.",
      "Stir well until it's fully mixed.",
      "Consume this mixture in the morning for memory and cognitive support.",
    ],
    CommonUsage: "Morning",
    link: "https://www.netmeds.com/images/cms/magefan_blog/nmslite/1650355777_ghee-butter_480x180.jpg",
  },
  {
    Name: "Neem Oil",
    Ingredients: ["Cold-pressed Neem oil"],
    Instructions: [
      "Take a small amount of Neem oil in your palm.",
      "Gently massage it onto the skin or scalp.",
      "Leave it on for at least 30 minutes or overnight.",
      "Rinse thoroughly with warm water.",
      "Use Neem oil as needed for skin and hair health.",
    ],
    CommonUsage: "As needed for skin and hair health",
    link: "https://t4.ftcdn.net/jpg/01/70/05/19/360_F_170051927_5uCnFZGKB4H8bulJKUKaDAiKaPyu2xJx.jpg",
  },
  {
    Name: "Guggul Capsules",
    Ingredients: [],
    Instructions: [
      "Follow the dosage instructions on the Guggul capsule packaging.",
      "Typically, Guggul capsules are taken with warm water after meals.",
      "Use as directed by an Ayurvedic practitioner for cholesterol management and reducing inflammation.",
    ],
    CommonUsage: "As directed by an Ayurvedic practitioner",
    link: "https://www.elisirlife.it/en/blog/wp-content/uploads/2020/10/Guggul.jpg",
  },
  {
    Name: "Shatavari Powder",
    Ingredients: ["1 teaspoon of Shatavari powder", "Warm milk or water"],
    Instructions: [
      "Measure one teaspoon of Shatavari powder.",
      "Heat a cup of milk or water until warm (not boiling).",
      "Add the Shatavari powder to the warm liquid.",
      "Stir well until it's fully mixed.",
      "Consume this mixture once a day, preferably in the morning, to support female reproductive health.",
    ],
    CommonUsage: "Morning",
    link: "https://5.imimg.com/data5/YW/WH/YT/SELLER-11783855/shatavari-powder-asparagus-racemosus.jpg",
  },
  {
    Name: "Turmeric Milk",
    Ingredients: [
      "1 teaspoon of Turmeric powder",
      "1 cup of warm milk",
      "Honey (optional)",
    ],
    Instructions: [
      "Measure one teaspoon of Turmeric powder.",
      "Add it to a cup of warm milk.",
      "Stir well, and you can sweeten with honey if desired.",
      "Consume this mixture in the evening for its anti-inflammatory and joint health benefits.",
    ],
    CommonUsage: "Evening",
    link: "https://www.indianveggiedelight.com/wp-content/uploads/2020/03/turmeric_milk-2-1.jpg",
  },
];
